import React from 'react';
import { Container } from 'atoms/Container';
import { AlphabeticalItemsPage } from 'organisms/AlphabeticalItemsPage';
import { BrandsPageContainerProps } from 'pages/StoryBlok/AllBrands/types';
import { getBrandsBlok } from 'modules/stroyblok/api';

export const BrandsPageContainer: React.FC<BrandsPageContainerProps> = async ({
  params,
}) => {
  const brands = await getBrandsBlok(params?.locale);

  return (
    <Container>
      <AlphabeticalItemsPage tKey={'brands-page.title'} items={brands} />
    </Container>
  );
};
